/**
 * Layout metrics for ListingCard mobile/desktop info blocks.
 * Used by SectionListings.calculateCarouselHeight — keep in sync with ListingCard.module.css (⚠️ comments).
 */

import { FONT_SCALE } from '../../styles/fontScale';

export const LISTING_CARD_MOBILE_METRICS = {
  aspectRatio: 16 / 10,
  categoryEyebrowHeight: 10.5 * FONT_SCALE + 6,
  titleHeight: 15 * 1.25 * 2 * FONT_SCALE,
  titleMarginBottom: 10,
  cardInfoPaddingVertical: 12 + 13,
  // ⚠️ footer: padding-top + hairline + avatar + gap + rating + shipping range line
  footerHeight: 10 + 1 + 22 + 6 + 16 * FONT_SCALE + 4 + 12 * 1.2 * FONT_SCALE,
};

export const LISTING_CARD_DESKTOP_METRICS = {
  aspectRatio: 1,
  categoryEyebrowHeight: 9.5 * FONT_SCALE + 6,
  titleHeight: 14 * 1.3 * 2 * FONT_SCALE,
  titleMarginBottom: 12,
  cardInfoPaddingVertical: 12 + 14,
  // ⚠️ footer: padding-top + avatar + gap + rating + shipping range line
  footerHeight: 2 + 22 + 6 + 15 * FONT_SCALE + 4 + 12 * 1.2 * FONT_SCALE,
};

/**
 * @param {number} lineCount
 * @returns {number}
 */
export const estimateMobilePriceBlockHeight = (lineCount = 1) => {
  const m = LISTING_CARD_MOBILE_METRICS;
  return m.titleHeight + m.titleMarginBottom;
};

/**
 * @param {{ priceLineCount?: number }} options
 * @returns {number}
 */
export const estimateMobileCardInfoHeight = ({ priceLineCount = 1 } = {}) => {
  const m = LISTING_CARD_MOBILE_METRICS;
  return (
    m.categoryEyebrowHeight +
    estimateMobilePriceBlockHeight(priceLineCount) +
    m.footerHeight +
    m.cardInfoPaddingVertical
  );
};

/**
 * @returns {number}
 */
export const estimateDesktopCardInfoHeight = () => {
  const m = LISTING_CARD_DESKTOP_METRICS;
  return (
    m.categoryEyebrowHeight +
    m.titleHeight +
    m.titleMarginBottom +
    m.footerHeight +
    m.cardInfoPaddingVertical
  );
};
